module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av257-c2453fc01c1b5f0037312570da2e7391.jpg";